import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import TitlesList from '../components/TitlesList'

export default function ManageTitles() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Titles</h1>
        <Link to="/new-title"><button className="memberAddButton">Add New</button></Link>
      </div>
        <TitlesList />
    </div>
  )
}
